module.exports = __webpack_public_path__ + "static/proof-943556cca4e58a72cca8e3aea4dc1df5.png";